<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.options") }}</v-toolbar-title>
      <v-spacer />
      <v-btn :to="{ name: 'create-option' }" large class="primary">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      :pathName="
        `packages/${$route.params.slug}/option-groups/${$route.params.group_id}/options`
      "
      resName="options"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.price }}</td>
        <td class="text-sm-center">{{ item.persons_count }}</td>
        <td class="text-sm-center">{{ item.children_count }}</td>

        <td class="text-sm-center">
          <v-btn icon color="info" :to="`options/${item.id}/edit`">
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "PackageOptionGroups",
  data() {
    return {
      headers: ["name", "price", "persons_count", "children_count", "actions"]
    };
  },
  methods: {
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    }
  }
};
</script>
